import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hourMinutes',
    standalone: false
})
export class HourMinutesPipe implements PipeTransform {
	transform(minutes: number): string {
		if (minutes == null || isNaN(minutes)) {
			return '0:00';
		}

		const isNegative = minutes < 0;
		const absMinutes = Math.abs(minutes);
		const hours = Math.trunc(absMinutes / 60);
		const remainingMinutes = absMinutes % 60;

		const formatted = `${hours}:${remainingMinutes.toString().padStart(2, '0')}`;
		return isNegative ? `-${formatted}` : formatted;
	}
}
